/* LAVI SMALL ORDER FEE
   ---------------------------------------------------------------------------
   Lavi Industries charges TCC a $25 fee when the Lavi items on an order total
   less than $250. This keeps one "Lavi Small Order Fee" line in the cart
   exactly while that is true, and removes it the moment it is not:

     Lavi subtotal = 0            -> no fee
     Lavi subtotal $0.01-$249.99  -> fee x1
     Lavi subtotal >= $250        -> no fee

   The subtotal is the sum of final_line_price (after discounts) of every line
   whose vendor is "Lavi Industries", EXCLUDING the fee line itself, which also
   carries that vendor so the mixed-vendor notice and the PO generator group it
   with Lavi.

   CONFIG comes from snippets/_meta-tags.liquid as window.TCC_LAVI_FEE:
     variant  fee variant id (product lavi-small-order-fee, status UNLISTED)
     min      threshold in cents
     sync     true when Liquid saw the cart out of step at page render

   HOW IT STAYS IN STEP
   1. Every cart write the theme makes goes through fetch (cart-provider.js,
      product forms, "Complete your setup" rows). fetch is wrapped: after a
      successful /cart/add|change|update|clear, the fee is reconciled BEFORE
      the caller sees the response, so the drawer, counter and notification
      the theme fetches next already include the fee.
   2. Non-JS cart writes end in a page load, where Liquid computes the same
      rule and sets sync=true if the cart is wrong.
   3. On the cart page a correction reloads the page, because cartChange's
      section HTML was rendered before the fee changed. The reload only happens
      after /cart/update.js confirms the new quantity, so it cannot loop.

   The fee line's quantity controls and remove button are hidden by CSS in
   _meta-tags.liquid. Removing it anyway (devtools) is undone by the next cart
   write or page load.

   NOT COVERED: "Buy it now" skips the cart entirely, so dynamic checkout
   buttons are hidden on Lavi product pages (also _meta-tags.liquid). */
(function () {
  'use strict';
  var C = window.TCC_LAVI_FEE;
  if (!C || !C.variant || window.__tccLaviFee || typeof window.fetch !== 'function') return;
  window.__tccLaviFee = true;

  var VENDOR = 'lavi industries';
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var origFetch = window.fetch.bind(window);
  var running = null;

  function json(r) { return r.ok ? r.json() : Promise.reject(r.status); }

  /* Resolves true when the fee quantity was changed. Concurrent calls share one run. */
  function reconcile() {
    if (running) return running;
    running = origFetch('/cart.js', { credentials: 'same-origin' })
      .then(json)
      .then(function (cart) {
        var sub = 0, have = 0;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (it.variant_id === C.variant) { have += it.quantity; continue; }
          if ((it.vendor || '').trim().toLowerCase() === VENDOR) sub += it.final_line_price;
        }
        var want = (sub > 0 && sub < C.min) ? 1 : 0;
        if (want === have) return false;

        var updates = {};
        updates[C.variant] = want;
        return origFetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(json)
          .then(function (after) {
            var now = 0;
            for (var j = 0; j < after.items.length; j++) {
              if (after.items[j].variant_id === C.variant) now += after.items[j].quantity;
            }
            return now === want;
          });
      })
      .catch(function () { return false; })
      .then(function (changed) { running = null; return changed; });
    return running;
  }

  function onCartPage() { return /^\/cart\/?$/.test(location.pathname); }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (!CART_WRITE.test(url)) return p;
    return p.then(function (res) {
      if (!res.ok) return res;
      return reconcile().then(function (changed) {
        if (changed && onCartPage()) location.reload();
        return res;
      });
    });
  };

  function start() {
    if (!C.sync) return;
    reconcile().then(function (changed) {
      if (changed && onCartPage()) location.reload();
    });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
